"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useOnClick = require("./useOnClick");
Object.keys(_useOnClick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useOnClick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useOnClick[key];
    }
  });
});
var _useProduct = require("./useProduct");
Object.keys(_useProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useProduct[key];
    }
  });
});
